import { styled } from '@/stitches.config';
import { DesktopCard } from './desktop-card';
import { WorkProject } from '@/lib/schemas/work-project';

type DesktopCardListProps = {
  cards: Array<WorkProject>;
  canAnimate: boolean;
};

export function DesktopCardList({ cards, canAnimate }: DesktopCardListProps) {
  return (
    <Cards>
      {cards.map((card) => {
        return (
          <DesktopCard
            key={card.target._id}
            card={card}
            canAnimate={canAnimate}
          />
        );
      })}
    </Cards>
  );
}

/**
 * Explanation about the gutters (or lack thereof)
 * Previously this implementation used grid-gap to get whitespace between the ListItem blocks.
 * The problem with gutters is that you can't use aspectRatio anymore. The gap will distort the aspectRatio and items won't align.
 * Without the aspectRatio property, you get collapsing grid rows.
 *
 * To circumvent this, we don't apply any gutters. To visually mimick the gutters, we position the content absolute with an inset of '$4'
 * To the outsides of the grid container we apply a negative margin with the same value as the inset, so it aligns flush with the content above
 * and below it.
 *
 */
const Cards = styled('ol', {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gridAutoRows: 'repeat(3, minmax(0, 1fr))',
  mx: '-$2',

  gridAutoFlow: 'dense',

  '@bp4': {
    mx: '-$4',
    gridColumn: '7 / span 11',
  },

  '@bp5': {
    gridColumn: '6 / span 12',
  },
});
